import { z } from 'zod';

import type { MessageKey } from '@/modules/localizations/translations/types';

// To prevent circular dependencies, we cannot import directly from TOTPFromQRCodeButton
import { isTOTPError, type TOTPError } from '../components/TOTPFromQRCodeButton/errors/TOTPError';
import { Fields, SecretType } from '../constants';
import { isValidTOTP } from '../utilities';
import { basicSecretFormSchema } from './basicSecretFormSchema';

export const passwordSecretFormSchema = basicSecretFormSchema.merge(
    z.object({
        [Fields.TYPE]: z.literal(SecretType.Password),
        [Fields.USERNAME]: z.string().optional(),
        [Fields.WEB]: z.string().optional(),
        [Fields.PASSWORD]: z.string().optional(),
        [Fields.TOTP]: z
            .union([
                z.string().refine(val => isValidTOTP(val), {
                    message: 'form.error.TOTP.general' satisfies MessageKey,
                }),
                z
                    .custom<TOTPError>(val => isTOTPError(val))
                    .superRefine((val, ctx) => {
                        ctx.addIssue({
                            code: z.ZodIssueCode.custom,
                            message: `form.error.TOTP.qrcode.${val.code}` satisfies MessageKey,
                        });
                    }),
            ])
            .nullish(),
        [Fields.HAS_TOTP]: z.boolean().optional(),
        [Fields.PASSKEY]: z
            .object({
                credentialId: z.string(),
                createdAt: z.string(),
            })
            .nullish(),
        [Fields.PASSKEY_CREDENTIAL_ID]: z.string().nullish(),
    }),
);
